import React from 'react'

import {Layout, Link  } from "actb"
import {
    ImageHarvester, ImageOnion, ImageCloud, ImagePipeline,
    ImageEventSourcingAws, ImageIntegration, ImageJenkinsK8s,
    ImageAirflow,
} from "actl"
// import Hexagon from 'react-hexagon'

// import { Carousel } from 'antd'



import "./index.less"

import { Icon, Avatar, Carousel,
    Row, Col
} from 'antd';


const Panel = Layout.Panel;

export default function PostsPage({pageContext:context}){
  const props = Object.assign({}, {layout:{footer:true},
        title: "ACT labs consultancy. React, Python, node.js, and other web technologies"
    }, context.frontmatter)

  return (
    <Layout className="home-page" {...props}>
      <Panel className="home-page__content" style={{position:"relative", padding:0}}>
        <div className="home-page__side-panel">
            <Row></Row>
            <Row>
                <Col offset={3} span={1}>
                    <Avatar size="large" style={{backgroundColor:"#00b0ff"}}>React</Avatar>
                </Col>
                <Col offset={15} span={1}>
                    <Avatar size="large" style={{backgroundColor:"#ffff00", color:"#0d47a1"}}>Python</Avatar>
                </Col>
            </Row>
            <Row></Row>
            <Row>
            <Col offset={10} span={1}>
                    <Avatar size="large" style={{backgroundColor:"#ff3d00"}}>AWS</Avatar>
                </Col>
            </Row>
            <Row></Row>
            <Row>
                <Col offset={4} span={1}>
                    <Avatar size="large" style={{backgroundColor:"#0d47a1"}}>Gatsby</Avatar>
                </Col>
            </Row>

        </div>
        <Link className="home-page__image" to="/" title="ACT labs develop modern web applications">
            <ImageCloud/>
        </Link>
        <div className="home-page__placeholder"></div>
        <div className="home-page__about-blog">
            <h3>Welcome to my blog</h3>
            <p>This is a blog about intreating modern trends in software development. See
                {" "} <Link to="/posts/" title="ACT blog posts">posts</Link> and
                {" "} <Link to="/snippets/" title="ACT blog useful code snippets">snippets</Link> - assortment of interesting random code extracts.</p>
            <p> The blog itself is a static site using <i>Gatsby</i> and other <i>React</i> goodness.</p>
        </div>
        <div className="home-page__posts">
            <div style={{marginLeft:2}}><Icon type="edit" /></div>
            <Carousel style={{padding:"10px 5px"}}>
                <div className="post-card">
                    <Link to="https://www.facebook.com/ACT7LAB" title="blog posts about modern web technologies">
                        <ImageHarvester/>
                    </Link>
                    <div className="post-card">
                        <h3><Link to="https://www.facebook.com/ACT7LAB" title="modern tech stack">Contact me</Link></h3>
                        <p>Here is my lab (<i>ACT Labs</i>) to play with latest cool technologies.</p>
                        <p>I have a big experience with <i>React, CSS, Typescript, Python, AWS</i>, and more...</p>
                    </div>
                </div>
                <div className="post-card">
                    <Link to="/posts/ddd-in-react/" title="Domain Driven Design for React applications">
                        <ImageOnion/>
                    </Link>
                    <Link to="/posts/ddd-in-react/" title="Domain Driven Design for React applications">
                        <h3>Domain Driven Design for React applications</h3>
                    </Link>
                    <p>Domain Driven Design, which recently grew in popularity and adoption across industry,
                        is often viewed as a helpful paradigm, providing new, interesting ways to think about application architecture.
                    </p>
                    <p>This post analyses how different React application layers may map to various DDD concepts and how it may impact your
                        project structure, testing and development procedures.
                    </p>
                </div>
                <div className="post-card">
                    <Link to="/posts/jenkins-k8s/" title="Deploying Kubernetes applications using Helm 3 and Jenkins">
                        <ImageJenkinsK8s/>
                    </Link>
                    <Link to="/posts/jenkins-k8s/" title="Deploying Kubernetes applications using Helm 3 and Jenkins">
                        <h3>Deploying Kubernetes applications using Helm 3 and Jenkins</h3>
                    </Link>
                    <p>Deploying Jenkins CI/CD pipelines to Kubernetes cluster has many advantages: build system
                        easily scales up and down, it is easy to run tasks in parallel, etc.
                    </p>
                    <p>And, in combination with Helm, Kubernetes application deployments become easy.</p>
                </div>
                <div className="post-card">
                    <Link to="/posts/airflow-gke" title="Apache Airflow on GKE: installation and test drive">
                        <ImageAirflow/>
                        <h3>Apache Airflow on GKE: installation and test drive</h3>
                    </Link>
                    <p>Apache Airflow is a powerful workflow management platform.
                        In this series of blog posts we install it and test basic Google specific Airflow hooks.
                    </p>
                </div>
                <div className="post-card">
                    <Link to="/posts/cypress/" title="Integration testing, tips and tricks">
                        <ImageIntegration/>
                    </Link>
                    <Link to="/posts/cypress/" title="Integration testing, tips and tricks">
                        <h3>Integration testing, tips and tricks</h3>
                    </Link>
                    <p>Growing interest to integration testing encourages new best practices shaping. Among the most commonly mentioned: Page Objects
                        and Application Actions shown to play nicely together.
                    </p>
                    <p>Cypress testing framework comes with plugin for Cucumber tests, allowing BDD style testing with user stories and up-to-date documentation.
                    </p>
                </div>
                <div className="post-card">
                    <Link to="/posts/aws-event-sourcing/" title="Simple event sourcing using AWS DynamoDB">
                        <ImageEventSourcingAws/>
                    <h3>Event sourcing and AWS </h3>
                    </Link>
                    <p>Quickly shifting business requirements is another challenge of modern enterprise applications. To cope with it, microservices
                has recently became popular.
                    </p>
                    <p><i>AWS lambdas</i> not only liberate enterprise developers from the need to manage IT infrastructure, but also come
                    with a power to design complex systems.</p>
                </div>
                <div className="post-card">
                    <Link to="/posts/act-blog/" title="Gatsby-plugin-combine to create complex Gatsby pipeline">
                        <ImagePipeline/>
                    </Link>
                    <Link to="/posts/act-blog/" title="Gatsby-plugin-combine to create complex Gatsby pipeline">
                        <h3>Static asset pipelines</h3>
                    </Link>
                    <p>Static content is a way to overcome problems with scalability. Highly optimized content, NGINX, free static file hosting and CDN are
                        just a few benefits that come with a static.
                    </p>
                    <p>This post describes <i>Gatsby</i> - a powerful tool to quickly develop customer tailored asset
                    {" "}<Link to="/posts/act-blog/" title="ACT - Gatsby starter for websites/enterprise applications">processing pipelines...</Link> </p>
                </div>
            </Carousel>
        </div>

      </Panel>
    </Layout>
  )
}

